/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { TicketEditComponent, setupFormForMilestone } from '../ticket-edit.component';
import { TicketEditService } from '../../ticket-edit.service';
import { UntypedFormBuilder } from '@angular/forms';
import { PlanState } from 'src/app/services/plan-state.service';
import { ConstraintAcceptanceService } from 'src/app/modules/ticket-edit/constraint-acceptance.service';
import { PlanAccessCheck } from 'src/app/services/PlanAccessCheck';
import { FeatureFlagManager } from 'src/app/services/FeatureFlagManager';
import * as strings from '@touchplan/strings';

@Component({
	selector: 'multi-edit-milestone',
	templateUrl: './multi-edit-milestone.component.html',
	styleUrls: ['./multi-edit-milestone.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiEditMilestoneComponent extends TicketEditComponent implements OnInit {
	public appStrings = strings;
	constructor(
		protected ticketEditService: TicketEditService,
		protected formBuilder: UntypedFormBuilder,
		protected planState: PlanState,
		protected cd: ChangeDetectorRef,
		protected constraintAcceptanceService: ConstraintAcceptanceService,
		protected planAccessCheck: PlanAccessCheck,
		protected featureFlagManager: FeatureFlagManager
	) {
		super(
			ticketEditService,
			formBuilder,
			planState,
			cd,
			constraintAcceptanceService,
			planAccessCheck,
			featureFlagManager
		);
		setupFormForMilestone(this.editForm);
	}

	public ngOnInit() {
		super.ngOnInit();
	}
}
